import React, { useState } from "react";
import InfoOutlinedIcon from "@mui/icons-material/InfoOutlined";
import Popover from "@mui/material/Popover";
import "./LayerInfoIcon.css";

const LayerInfoIcon = ({
  description,
  testId,
  anchorOrigin = { vertical: "bottom", horizontal: "left" },
  transformOrigin = { vertical: "top", horizontal: "left" },
}) => {
  const [anchorEl, setAnchorEl] = useState(null);
  const open = Boolean(anchorEl);

  const handleOpen = (e) => setAnchorEl(e.currentTarget);
  const handleClose = () => setAnchorEl(null);

  return (
    <>
      <InfoOutlinedIcon
        className={`layer-info-icon ${open ? "layer-info-icon--active" : ""}`}
        onMouseEnter={handleOpen}
        onMouseLeave={handleClose}
        data-testid={testId ? `${testId}-info-icon` : "layer-info-icon"}
      />
      <Popover
        className="layer-info-popover"
        open={open}
        anchorEl={anchorEl}
        onClose={handleClose}
        anchorOrigin={anchorOrigin}
        transformOrigin={transformOrigin}
        disableRestoreFocus
        disableScrollLock
      >
        {description && (
          <div
            className="layer-info-content"
            data-testid={testId ? `${testId}-info-popover` : "layer-info-popover"}
          >
            {description}
          </div>
        )}
      </Popover>
    </>
  );
};

export default React.memo(LayerInfoIcon);